import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  QuotationEnrichedDto,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}files/${COMMON_QUERY_PARAMS.FILE_ID}/quotation/pendingCustomerValidation`;

export interface GetPendingCustomerValidationQuotationByFileIdRequestArgs {
  fileId: string;
}

export const getPendingCustomerValidationQuotationByFileIdRequest = ({
  fileId,
}: GetPendingCustomerValidationQuotationByFileIdRequestArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getPendingCustomerValidationQuotationByFileIdQuery = async (
  payload: GetPendingCustomerValidationQuotationByFileIdRequestArgs,
): Promise<
  BackResponse<QuotationEnrichedDto | undefined> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<QuotationEnrichedDto | undefined>>(
      getPendingCustomerValidationQuotationByFileIdRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
